var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDoc(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 27.704,
    height: 24.688,
    viewBox: "0 0 27.704 24.688",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_2347",
    "data-name": "Group 2347",
    transform: "translate(-325.184 -441.717)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "contract",
    d: "M8.126,3A2.119,2.119,0,0,0,6,5.126v17.01a2.126,2.126,0,0,0,2.126,2.126h4.253V22.232L14.6,20.01H8.126V17.884h8.6l2.126-2.126H8.126V13.631H20.98L23.01,11.6V9.379L16.631,3H8.126m7.442,1.595,5.847,5.847H15.568V4.595m7.6,10.1a.585.585,0,0,0-.425.17L21.66,15.949l2.222,2.211,1.084-1.074a.61.61,0,0,0,0-.84l-1.382-1.382a.578.578,0,0,0-.415-.17m-2.137,1.882-6.528,6.538v2.211h2.211l6.538-6.538-2.222-2.211Z",
    transform: "translate(319.184 438.717)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "check",
    d: "M6.16,17.836.265,11.942a.907.907,0,0,1,0-1.283L1.548,9.377a.907.907,0,0,1,1.283,0L6.8,13.347l8.505-8.505a.907.907,0,0,1,1.283,0l1.283,1.283a.907.907,0,0,1,0,1.283L7.443,17.836a.907.907,0,0,1-1.283,0Z",
    transform: "translate(334.75 448.303)",
    fill: "#00c742"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDoc);
export default __webpack_public_path__ + "static/media/doc.cdea07d629feb5aa70a1314b9b602255.svg";
export { ForwardRef as ReactComponent };